(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cookies-pageload-popup-notice"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const popup = document.getElementById("noticePopup");
  if (!popup) return;

  const closeBtn = document.getElementById("closeNoticePopup");
  const closeX = document.getElementById("closePopupX");
  const understandBtn = document.getElementById("understandPopup");

  const excludedPages = ['/pages/download', '/pages/portal', '/portal'];
  const currentPath = window.location.pathname.toLowerCase();
  const isExcluded = excludedPages.some(path => currentPath.startsWith(path));

  if (!isExcluded && !sessionStorage.getItem("noticePopupShown")) {
    popup.style.display = "flex";
    sessionStorage.setItem("noticePopupShown", "true");

    if (currentPath.startsWith("/ja")) {
      understandBtn.textContent = "理解しました";
    } else if (currentPath.startsWith("/zh")) {
      understandBtn.textContent = "我明白了";
    } else {
      understandBtn.textContent = "UNDERSTAND";
    }

    function closePopup() {
      popup.style.display = "none";
    }

    understandBtn.addEventListener("click", closePopup);
    closeX.addEventListener("click", closePopup);
    closeBtn.addEventListener("click", closePopup);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-image-with-text"] && !Shopify.designMode) return;
  try {
    
let cimtTargetUrl = null;
let cimtTargetBlank = true;

document.addEventListener('click', function (e) {
  const link = e.target.closest('.item_content[data-enable-popup="true"] a');
  if (!link) return;

  const linkText = link.textContent.trim().toLowerCase();

  // ✅ Trigger popup if link text contains "firmware" (case-insensitive)
  if (!linkText.toLowerCase().includes('firmware')) return;

  e.preventDefault();

  const container = link.closest('.item_content');

  cimtTargetUrl = link.href;
  cimtTargetBlank = link.target !== '_self';

  const popup = document.getElementById('cimtPopup');
  popup.querySelector('.cimt-popup-title').textContent = container.dataset.popupTitle;
  popup.querySelector('.cimt-popup-description').innerHTML = container.dataset.popupDescriptionHtml;
  popup.querySelector('.cimt-popup-confirm').textContent = container.dataset.popupButton;

  popup.classList.add('active');
});

document.getElementById('cimtPopupConfirm').addEventListener('click', function () {
  if (!cimtTargetUrl) return;

  cimtTargetBlank
    ? window.open(cimtTargetUrl, '_blank')
    : window.location.href = cimtTargetUrl;
});

document.addEventListener('click', function (e) {
  if (
    e.target.classList.contains('cimt-popup-overlay') ||
    e.target.classList.contains('cimt-popup-close')
  ) {
    document.getElementById('cimtPopup').classList.remove('active');
    cimtTargetUrl = null;
    cimtTargetBlank = true;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["one-style-main-page-banner-popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('confirmation-popup');
  const openBtn = document.getElementById('open-confirm-popup');
  const cancelBtn = document.getElementById('cancel-button');
  const confirmBtn = document.getElementById('confirm-button');
  const checkbox = document.getElementById('confirm-checkbox');

  // Open popup and prevent default link
  openBtn.addEventListener('click', (e) => {
    e.preventDefault();
    popup.style.display = 'flex';
  });

  // Close popup
  cancelBtn.addEventListener('click', () => {
    popup.style.display = 'none';
    checkbox.checked = false;
    confirmBtn.disabled = true;
  });

  // Enable confirm button when checkbox checked
  checkbox.addEventListener('change', () => {
    confirmBtn.disabled = !checkbox.checked;
  });

  // Redirect on confirm using CTA's href
  confirmBtn.addEventListener('click', () => {
    window.location.href = openBtn.href;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-load-popup"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const popup = document.getElementById("noticePopup");
  const closeBtn = document.getElementById("closeNoticePopup");

  // Show popup when page loads
  popup.style.display = "flex";

  // Close popup
  closeBtn.addEventListener("click", function() {
    popup.style.display = "none";
  });
});

  } catch(e) { console.error(e); }
})();
})();
